import { Transition } from "@headlessui/react"
import type { ReactNode } from "react"
import {
  Toaster as ToasterSonner,
  toast as toastSonner,
  type ExternalToast,
} from "sonner"
import { Card } from "../Card"

import s from "./Toast.module.scss"

/**
 * ⚠️ This is not supposed to be a long-term solution for Toast
 *
 * This is a very basic Toast component. I'm adding this because
 * we have none at the moment, and I want to move away from ConfettiBanner
 * reinventing the wheel and the entire carriage with it.
 *
 * It is based on sonner library because Shadcn uses it for Toasts,
 * so when we move to Shadcn it should be easier to migrate
 */

export const toast = (
  children: ReactNode,
  toastOptions: ExternalToast = {}
) => {
  const options = {
    duration: 5000,
    classNames: { content: s.toast__content },
    ...toastOptions,
  }

  return toastSonner.custom(
    () => (
      <Transition aria-live="polite" show appear>
        <div className={s.toast}>
          <Card borderRadius="small">
            <Card.Content>{children}</Card.Content>
          </Card>
        </div>
      </Transition>
    ),
    { ...options }
  )
}

export const Toaster = () => {
  return (
    <ToasterSonner
      style={{
        // Without this font-family persists even in headless/unstyled toast.
        fontFamily: "inherit",
      }}
      visibleToasts={1}
      position="top-center"
    />
  )
}
